/* Refer to IANA Time Zone Database for more information. */
const TimeZones = {
    Eastern: "America/New_York",
    Central: "America/Chicago",
    Mountain: "America/Denver",
    Pacific: "America/Los_Angeles",
    Alaska: "America/Anchorage",
    Hawaii: "Pacific/Honolulu",
};

/* Module Exports */
module.exports = {
    appConfigKey: "AfbgDFMV5w3CQfrul1CMH4tLS0BYFqsl7FyjPEsB",
    appConfigProd:
        "https://uae4khqoag.execute-api.us-east-1.amazonaws.com/prod",
    appConfigDev: "https://os46zn9hmk.execute-api.us-east-1.amazonaws.com/dev",
    appDocket: "www.financialaidantitrustsettlement.com", // Must match CMS entry
    /**
     * Multi-docket layout: first path segments that select a CMS docket keyed by
     * `<appDocket>/<segment>` instead of being treated as a page slug. The root
     * (`/`) renders the bare `appDocket`. Consumed by ./index.js (imported
     * directly; not injected via webpack DefinePlugin). Leave empty/omit for
     * single-docket sites.
     */
    pathDockets: [
        "caltech-johns-hopkins-settlement",
        "university-of-chicago-settlement",
    ],
    reCAPTCHAv3: "6LeVdgEVAAAAAGLdvtrwMCDZcDZzJ300FZHqvmud",
    appPayMethod: "", // Digital Disbursements
    cookieDuration: 30, // Days
    claimMethod: "claimsV4Post",
    languages: ["en"],
    appDomain: {
        options: {
            claimDeadlineTimezone: TimeZones.Pacific,
            courtDateTimezone: TimeZones.Eastern,
            officialBanner: {
                display: true,
                pageLead: false, // If true, uses the CMS PageLead HTML as the banner content and suppresses the home page modal
                content: {}, // Per-language overrides: { en: "English text", es: "Spanish text" }
            },
            /**
             * Provide titles, types, or slugs that should always display as full date/time.
             * Examples:
             *  - "Hearing" (matches by translated title)
             *  - "final-approval-hearing" (matches slug)
             *  - { title: "Fairness Hearing" }
             *  - { type: "hearing" }
             */
            importantDatesUseDateTime: [],
        },
    },
    sentry: {
        dsn: "", // Sentry DSN
        project: "", // Sentry project name
    },
};
